import { NavContextType } from "src/components/navigation/NavContext"
import { Portal } from "src/components/navigation/Portal"
import { AgencyOperationsAdminBookingLayout } from "src/components/agency/operations/administrator/bookings/AgencyOperationsAdminBookingLayout";
import { Icons } from "src/components/ui/Icons"

import { NotFound } from "src/screens/global/NotFound";

import { AgencyOperationsAdminBooking } from "src/screens/agency/operations/administrator/bookings/AgencyOperationsAdminBooking";
import { AgencyOperationsAdminBookings } from "src/screens/agency/operations/administrator/bookings/AgencyOperationsAdminBookings";

import { AgencyOperationsAdminHome } from "src/screens/agency/operations/administrator/AgencyOperationsAdminHome";

import { AgencyOperationsAdminUsers } from "src/screens/agency/operations/administrator/users/AgencyOperationsAdminUsers";

import { AgencyOperationsAdminVenue } from "src/screens/agency/operations/administrator/venues/AgencyOperationsAdminVenue";
import { AgencyOperationsAdminVenues } from "src/screens/agency/operations/administrator/venues/AgencyOperationsAdminVenues";
import { AgencyOperationsAdminVenueLayout } from "src/components/agency/operations/administrator/venues/AgencyOperationsAdminVenueLayout";
import { AgencyOperationsAdminVenueBreadCrumb } from "src/components/agency/operations/administrator/venues/AgencyOperationsAdminVenueBreadcrumb";
import { AgencyOperationsAdminVenueUsers } from "src/screens/agency/operations/administrator/venues/users/AgencyOperationsAdminVenueUsers";
import { AgencyOperationsAdminVenueAreaBreadCrumb } from "src/components/agency/operations/administrator/venues/areas/AgencyOperationsAdminVenueAreaBreadcrumb";
import { AgencyOperationsAdminVenueAreaLayout } from "src/components/agency/operations/administrator/venues/areas/AgencyOperationsAdminVenueAreaLayout";
import { AgencyOperationsAdminVenueAreas } from "src/screens/agency/operations/administrator/venues/areas/AgencyOperationsAdminVenueAreas";
import { AgencyOperationsAdminVenueGuidelines } from "src/screens/agency/operations/administrator/venues/guidelines/AgencyOperationsAdminVenueGuidelines";
import { AgencyOperationsAdminVenueAreaGuidelines } from "src/screens/agency/operations/administrator/venues/areas/guidelines/AgencyOperationsAdminVenueAreaGuidelines";
import { AgencyOperationsAdminVenueBookings } from "src/screens/agency/operations/administrator/venues/bookings/AgencyOperationsAdminVenueBookings";
import { AgencyOperationsAdminTalents } from "src/screens/agency/operations/administrator/talent/AgencyOperationsAdminTalents";
import { AppShellLayout } from "src/components/ui/AppShellLayout";
import { RouteDrawer } from "src/components/navigation/RouteDrawer";
import { AgencyOperationsAdminVenueAreaOverlay } from "src/screens/agency/operations/administrator/venues/areas/AgencyOperationsAdminVenueAreaOverlay";
import { AgencyOperationsAdminVenueAreaGuidelinesOverlay } from "src/screens/agency/operations/administrator/venues/areas/guidelines/AgencyOperationsAdminVenueAreaGuidelinesOverlay";
import { AgencyOperationsAdminVenueArea } from "src/screens/agency/operations/administrator/venues/areas/AgencyOperationsAdminVenueArea";
import { AgencyOperationsAdminVenueBookingLayout } from "src/components/agency/operations/administrator/venues/bookings/AgencyOperationsAdminVenueBookingLayout";
import { AgencyOperationsAdminVenueBooking } from "src/screens/agency/operations/administrator/venues/bookings/AgencyOperationsAdminVenueBooking";
import { AgencyOperationsAdminVenueBookingBreadCrumb } from "src/components/agency/operations/administrator/venues/bookings/AgencyOperationsAdminVenueBookingBreadcrumb";
import { AgencyOperationsAdminVenueBookingOverlay } from "src/screens/agency/operations/administrator/venues/bookings/AgencyOperationsAdminVenueBookingOverlay";
import { AgencyOperationsAdminVenueBookingGuidelines } from "src/screens/agency/operations/administrator/venues/bookings/guidelines/AgencyOperationsAdminVenueBookingGuidelines";
import { AgencyOperationsAdminVenueBookingGuidelinesOverlay } from "src/screens/agency/operations/administrator/venues/bookings/guidelines/AgencyOperationsAdminVenueBookingGuidelinesOverlay";
import { AgencyOperationsAdminBookingBreadCrumb } from "src/components/agency/operations/administrator/bookings/AgencyOperationsAdminBookingBreadcrumb";
import { AgencyOperationsAdminBookingOverlay } from "src/screens/agency/operations/administrator/bookings/AgencyOperationsAdminBookingOverlay";
import { AgencyOperationsAdminBookingGuidelines } from "src/screens/agency/operations/administrator/bookings/guidelines/AgencyOperationsAdminBookingGuidelines";
import { AgencyOperationsAdminBookingGuidelinesOverlay } from "src/screens/agency/operations/administrator/bookings/guidelines/AgencyOperationsAdminBookingGuidelinesOverlay";
import { AgencyOperationsAdminTalentLayout } from "src/components/agency/operations/administrator/talent/AgencyOperationsAdminTalentLayout";
import { AgencyOperationsAdminTalent } from "src/screens/agency/operations/administrator/talent/AgencyOperationsAdminTalent";
import { AgencyOperationsAdminTalentBreadCrumb } from "src/components/agency/operations/administrator/talent/AgencyOperationsAdminTalentBreadcrumb";
import { AgencyOperationsAdminTalentGuidelines } from "src/screens/agency/operations/administrator/talent/guidelines/AgencyOperationsAdminTalentGuidelines";
import { AgencyOperationsAdminTalentOverlay } from "src/screens/agency/operations/administrator/talent/AgencyOperationsAdminTalentOverlay";
import { AgencyOperationsAdminTalentGuidelinesOverlay } from "src/screens/agency/operations/administrator/talent/guidelines/AgencyOperationsAdminTalentGuidelinesOverlay";
import { AgencyOperationsAdminThreads } from "src/screens/agency/operations/administrator/threads/AgencyOperationsAdminThreads";
import { AgencyOperationsAdminThreadLayout } from "src/components/agency/operations/administrator/threads/AgencyOperationsAdminThreadLayout";
import { AgencyOperationsAdminThreadBreadCrumb } from "src/components/agency/operations/administrator/threads/AgencyOperationsAdminThreadBreadcrumb";
import { AgencyOperationsAdminThread } from "src/screens/agency/operations/administrator/threads/AgencyOperationsAdminThread";
import { AgencyOperationsAdminThreadOverlay } from "src/screens/agency/operations/administrator/threads/AgencyOperationsAdminThreadOverlay";
import { AgencyOperationsAdminBookingsCalendar } from "src/screens/agency/operations/administrator/bookings/AgencyOperationsAdminBookingsCalendar";
import { CalendarPortal } from "src/components/calendar/CalendarPortal";
import { AgencyOperationsAdminTalentBlackouts } from "src/screens/agency/operations/administrator/talent/blackouts/AgencyOperationsAdminTalentBlackouts";
import { AgencyOperationsAdminTalentBlackoutsOverlay } from "src/screens/agency/operations/administrator/talent/blackouts/AgencyOperationsAdminTalentBlackoutsOverlay";
import { AgencyOperationsAdminTalentDocuments } from "src/screens/agency/operations/administrator/talent/documents/AgencyOperationsAdminTalentDocuments";
import { AgencyOperationsAdminTalentDocumentsOverlay } from "src/screens/agency/operations/administrator/talent/documents/AgencyOperationsAdminTalentDocumentsOverlay";
import { UserProfile } from "src/screens/user/UserProfile";
import { AgencyOperationsAdminGuidelines } from "src/screens/agency/operations/administrator/guidelines/AgencyOperationsAdminGuidelines";

export const AgencyOperationsAdminRoutes = (): NavContextType => ({
    routes: [
        {
            path: '/',
            element: <AppShellLayout />,
            breadcrumb: 'Layout',
            children: [
                { index: true, element: <AgencyOperationsAdminHome />, breadcrumb: 'Home' },
                { path: "profile", element: <UserProfile />, breadcrumb: 'User Profile' },
                {
                    path: "guidelines",
                    element: <Portal />,
                    breadcrumb: 'Guidelines',
                    children: [
                        { index: true, element: <AgencyOperationsAdminGuidelines /> }
                    ]
                },
                {
                    path: "users",
                    element: <Portal />,
                    breadcrumb: 'Users',
                    children: [
                        { index: true, element: <AgencyOperationsAdminUsers /> },
                    ]
                },
                {
                    path: "calendar",
                    element: <CalendarPortal />,
                    breadcrumb: 'Calendar',
                    children: [
                        { index: true, element: <AgencyOperationsAdminBookingsCalendar /> },
                    ]
                },
                {
                    path: "inbox",
                    element: <Portal />,
                    breadcrumb: 'Inbox',
                    children: [
                        { index: true, element: <AgencyOperationsAdminThreads /> },
                        {
                            path: ":threadId",
                            element: <AgencyOperationsAdminThreadLayout />,
                            children: [
                                { index: true, element: <AgencyOperationsAdminThread />, breadcrumb: AgencyOperationsAdminThreadBreadCrumb }
                            ]
                        }
                    ]
                },
                {
                    path: "talent",
                    element: <Portal />,
                    breadcrumb: 'Talent',
                    children: [
                        { index: true, element: <AgencyOperationsAdminTalents /> },
                        {
                            path: ":talentId",
                            element: <AgencyOperationsAdminTalentLayout />,
                            children: [
                                { index: true, element: <AgencyOperationsAdminTalent />, breadcrumb: AgencyOperationsAdminTalentBreadCrumb },
                                { path: "guidelines", element: <AgencyOperationsAdminTalentGuidelines />, breadcrumb: 'Guidelines' },
                                { path: "blackouts", element: <AgencyOperationsAdminTalentBlackouts />, breadcrumb: 'Blackout Dates' },
                                { path: "documents", element: <AgencyOperationsAdminTalentDocuments />, breadcrumb: 'Documents' } 
                            ]
                        }
                    ]
                },
                {
                    path: "bookings",
                    element: <Portal />,
                    breadcrumb: "Bookings",
                    children: [
                        { index: true, element: <AgencyOperationsAdminBookings /> },
                        {
                            path: ":bookingId",
                            element: <AgencyOperationsAdminBookingLayout />,
                            children: [
                                { index: true, element: <AgencyOperationsAdminBooking />, breadcrumb: AgencyOperationsAdminBookingBreadCrumb },
                                { path: "guidelines", element: <AgencyOperationsAdminBookingGuidelines />, breadcrumb: 'Guidelines' }
                            ]
                        }
                    ]
                },
                {
                    path: "venues",
                    element: <Portal />,
                    breadcrumb: "Venues",
                    children: [
                        { index: true, element: <AgencyOperationsAdminVenues /> },
                        {
                            path: ":venueId",
                            element: <AgencyOperationsAdminVenueLayout />,
                            children: [
                                { index: true, element: <AgencyOperationsAdminVenue />, breadcrumb: AgencyOperationsAdminVenueBreadCrumb },
                                { path: "users", element: <AgencyOperationsAdminVenueUsers />, breadcrumb: 'Users' },
                                { path: "guidelines", element: <AgencyOperationsAdminVenueGuidelines />, breadcrumb: 'Guidelines' },
                                {
                                    path: "bookings",
                                    element: <Portal />,
                                    children: [
                                        { index: true, element: <AgencyOperationsAdminVenueBookings />, breadcrumb: 'Bookings' },
                                        {
                                            path: ":bookingId",
                                            element: <AgencyOperationsAdminVenueBookingLayout />,
                                            children: [
                                                { index: true, element: <AgencyOperationsAdminVenueBooking />, breadcrumb: AgencyOperationsAdminVenueBookingBreadCrumb },
                                                { path: "guidelines", element: <AgencyOperationsAdminVenueBookingGuidelines />, breadcrumb: 'Guidelines' }
                                            ]

                                        }
                                    ]
                                },
                                {
                                    path: "areas",
                                    element: <Portal />,
                                    children: [
                                        { index: true, element: <AgencyOperationsAdminVenueAreas />, breadcrumb: 'Areas' },
                                        {
                                            path: ":areaId",
                                            element: <AgencyOperationsAdminVenueAreaLayout />,
                                            children: [
                                                { index: true, element: <AgencyOperationsAdminVenueArea />, breadcrumb: AgencyOperationsAdminVenueAreaBreadCrumb },
                                                { path: "guidelines", element: <AgencyOperationsAdminVenueAreaGuidelines />, breadcrumb: 'Guidelines' }
                                            ]

                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                { path: "*", element: <NotFound />, breadcrumb: 'Not Found' }
            ]
        }
    ],
    overlays: [
        {
            path: "/inbox/:threadId",
            element: <RouteDrawer />,
            children: [
                {
                    element: <AgencyOperationsAdminThreadLayout />,
                    children: [
                        { index: true, element: <AgencyOperationsAdminThreadOverlay /> }
                    ]
                }
            ],
        },
        {
            path: "/bookings/:bookingId",
            element: <RouteDrawer />,
            children: [
                {
                    element: <AgencyOperationsAdminBookingLayout />,
                    children: [
                        { index: true, element: <AgencyOperationsAdminBookingOverlay /> },
                        { path: "guidelines", element: <AgencyOperationsAdminBookingGuidelinesOverlay /> },
                    ]
                }
            ],
        },
        {
            path: "/talent/:talentId",
            element: <RouteDrawer />,
            children: [
                {
                    element: <AgencyOperationsAdminTalentLayout />,
                    children: [
                        { index: true, element: <AgencyOperationsAdminTalentOverlay /> },
                        { path: "guidelines", element: <AgencyOperationsAdminTalentGuidelinesOverlay /> },
                        { path: "blackouts", element: <AgencyOperationsAdminTalentBlackoutsOverlay /> },
                        { path: "documents", element: <AgencyOperationsAdminTalentDocumentsOverlay /> },
                    ]
                }
            ],
        },
        {
            path: "/venues/:venueId/areas/:areaId",
            element: <RouteDrawer />,
            children: [
                {
                    element: <AgencyOperationsAdminVenueAreaLayout />,
                    children: [
                        { index: true, element: <AgencyOperationsAdminVenueAreaOverlay /> },
                        { path: "guidelines", element: <AgencyOperationsAdminVenueAreaGuidelinesOverlay /> },
                    ]
                }
            ],
        },
        {
            path: "/venues/:venueId/bookings/:bookingId",
            element: <RouteDrawer />,
            children: [
                {
                    element: <AgencyOperationsAdminVenueBookingLayout />,
                    children: [
                        { index: true, element: <AgencyOperationsAdminVenueBookingOverlay /> },
                        { path: "guidelines", element: <AgencyOperationsAdminVenueBookingGuidelinesOverlay /> },
                    ]
                }
            ],
        }
    ],
    menu: [
        {
            to: '/',
            label: 'Home',
            icon: Icons.home
        },
        {
            to: '/inbox',
            label: 'Inbox',
            icon: Icons.inbox
        },
        {
            to: '/bookings',
            label: 'Bookings',
            icon: Icons.location
        },
        {
            to: '/calendar',
            label: 'Calendar',
            icon: Icons.calendar
        },
        {
            to: '/venues',
            label: 'Venues',
            icon: Icons.tenants
        },
        {
            to: '/talent',
            label: 'Talent',
            icon: Icons.user
        },
        {
            to: '/users',
            label: 'Users',
            icon: Icons.user
        },
    ],
    mobile: [
        {
            to: '/',
            label: 'Home',
            icon: Icons.home
        },
        {
            to: '/bookings',
            label: 'Bookings',
            icon: Icons.location
        },
        {
            to: '/users',
            label: 'Users',
            icon: Icons.user
        },
    ]
})